export default __webpack_public_path__ + "static/media/minibox_owl.0965114d.png";